<template>
  <div class="page">
    <h1 class="heading" v-if="heading">{{ $t(heading) }}</h1>
    <p class="description" v-if="description">
      {{ $t(description) }}
      <br/><br/>
      <html-with-links :html="$t('THIS_FEATURE_IS_PART_OF_PLUS')"></html-with-links>
    </p>
    <sideloading-options :options="plusOptions" hide-name />
  </div>
</template>

<script>
import SideloadingOptions from '@/components/SideloadingOptions.vue';
import HtmlWithLinks from '@/components/HtmlWithLinks.vue';

export default {
  components: {
    HtmlWithLinks,
    SideloadingOptions,
  },
  data() {
    return {
      plusOptions: [],
    };
  },
  computed: {
    title() {
      return this.$t('ERROR');
    },
    heading() {
      return this.$route.query.title;
    },
    description() {
      return this.$route.query.description;
    },
  },
  created() {
    this.$api.getSideloadingOptions('plus').then((response) => {
      this.plusOptions = response;
    });
  },
};
</script>

<style lang="scss" scoped>
.page {
  max-width: 500px;
  text-align: center;
  margin: 0 auto;
}

.heading {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  line-height: 1.3;
}

.description {
  margin-bottom: 15px;
  line-height: 1.3;
}
</style>
